export default __webpack_public_path__ + "41aad818820200f845dc76c1bd2e3dd1.png";